import { Caption, CollectionIcon, css, LockIcon, Mode, styled, useModeContext } from 'canoe';
import { connectWithHammock, ENDPOINTS } from 'hammock';
import React from 'react';

import { CollectionDefinition } from '@candu-ai/collections/types';
import { CollectionTargetLocation, TargetLocationsEnglishNames } from 'craft/types';

interface CollectionLockedSettingProps {
  collectionsMetadata: CollectionDefinition[];
  collectionId: string;
  targetLocation: CollectionTargetLocation;
}

const LockedSettingWrapper = styled.div`
  ${({ theme }) => css`
    margin-bottom: ${theme.spaces.xs};
    margin-left: -${theme.spaces.xxs}; // to align lock icon to left
    display: flex;
    align-items: center;
  `}
`;

const LockedText = styled(Caption)<{ mode: Mode }>`
  ${({ theme, mode }) => css`
    margin: 0;
    color: ${theme.colors.OnyxGrayL20};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 1;

    ${mode === 'Dark' &&
    css`
      color: ${theme.colors.GlitterGray};
    `}
    // to override collection SVG sizing to match designs
    + span > svg {
      width: 11px;
      height: 11px;
    }
  `}
`;

export const CollectionLockedSettingImpl = React.memo(
  ({ collectionsMetadata, collectionId, targetLocation }: CollectionLockedSettingProps) => {
    const usedCollection = collectionsMetadata.find((c) => c.id === collectionId);
    const { mode } = useModeContext();

    return (
      <LockedSettingWrapper>
        <LockIcon color={mode === 'Dark' ? 'GlitterGray' : 'OnyxGrayL20'} />
        <LockedText element="label" mode={mode}>
          {TargetLocationsEnglishNames[targetLocation]} already set from{' '}
          {usedCollection?.collectionName}
        </LockedText>
        &nbsp;
        <CollectionIcon color={mode === 'Dark' ? 'GlitterGray' : 'OnyxGrayL20'} size="s" />
      </LockedSettingWrapper>
    );
  },
);

export const CollectionLockedSetting = connectWithHammock({
  endpoint: ENDPOINTS.collections,
  resourceName: 'collectionsMetadata',
})(CollectionLockedSettingImpl);
